module.exports = __webpack_public_path__ + "img/02.d3d7b78e.png";